
/**
 * 자료 유형
 */
export type EduAssetListResponseContentItemAssetType = typeof EduAssetListResponseContentItemAssetType[keyof typeof EduAssetListResponseContentItemAssetType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const EduAssetListResponseContentItemAssetType = {
  VIDEO: 'VIDEO',
  AUDIO: 'AUDIO',
  DOCUMENT: 'DOCUMENT',
  IMAGE: 'IMAGE',
  MARKDOWN: 'MARKDOWN',
  PDF: 'PDF',
  ZIP: 'ZIP',
  PRESENTATION: 'PRESENTATION',
  SPREADSHEET: 'SPREADSHEET',
  OTHER_ASSET: 'OTHER_ASSET',
} as const;
